import script from "./RFPArbitration.vue?vue&type=script&setup=true&lang=js"
export * from "./RFPArbitration.vue?vue&type=script&setup=true&lang=js"

import "./RFPArbitration.vue?vue&type=style&index=0&id=38843780&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38843780"]])

export default __exports__